<template>
  <div id="app-wrapper">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
:root {
  font-size: 16px;
}

html,
body {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background-color: transparent;
  position: relative;
}

body {
  font-family: "PingFang SC", "Helvetica Neue", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  width: 960px;
  height: 600px;
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
  background-color: transparent;
  transform-origin: top left;
  overflow: hidden;
}

#app-wrapper {
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: hidden;
}

* {
  user-select: none;
  box-sizing: border-box;
}

img,
svg {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
</style>
